import React, { useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";

import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Input,
    Row,
} from "reactstrap";

import EcommerceOrdersModal from "components/Common/EcommerceOrdersModal";
import CommonTable from "../../../components/Common/TableContainer";
import Spinners from "components/Common/Spinner";
import { pascalToCamel } from "helpers/GeneralHelper";
import { useJobContext } from "libs/context/JobContext";
import JobAddEditModal from "pages/AllCommonModal/JobAddEditModel/job-add-edit-model";
import { submitFilterData } from "model/JobModel";
import Loaders from "components/Common/Loaders";
import { usePermissionContext } from "libs/context/PermissionContext";

const Job = () => {
    const { permissionData } = usePermissionContext() || {};
    const { fetchJobContextData, jobContextData } = useJobContext() || {};
    const [jobAddEditModalOpen, setJobAddEditModalOpen] = useState(false);
    const [modal1, setModal1] = useState(false);
    const toggleViewModal = () => setModal1(!modal1);
    const [searchQuery, setSearchQuery] = useState("");
    const [jobData, setJobData] = useState("");
    const [loading, setLoading] = useState(false);
    const [itemId, setItemId] = useState(null);
    const [tableMetaData, setTableMetadata] = useState();
    const [commonFilterModalOpen, setCommonFilterModalOpen] = useState(false);

    const initialState = {
        title: "",
        candidateDeactive: false,
        forTools: false,
        status: true,
    };
    const [formData, setFormData] = useState(initialState);

    const filteredData = useMemo(() => {
        if (!searchQuery?.trim()) return jobData;

        return jobData?.filter((item) =>
            Object.values(item).some((val) =>
                String(val).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [jobData]);

    const jobActionPermissions = useMemo(
        () => ({
            canCreate: Boolean(permissionData?.JobAddAccess),
            canEdit: Boolean(permissionData?.JobUpdateAccess),
        }),
        [permissionData]
    );

    const hasAnyJobRowAction = useMemo(
        () => jobActionPermissions.canEdit,
        [jobActionPermissions]
    );

    const handleEdit = (row) => {
        setItemId(row?.id);
        setJobAddEditModalOpen(true);
    };

    useEffect(() => {
        fetchJobContextData();
        getJobList();
    }, []);

    useEffect(() => {
        const valueReModified = jobContextData?.table?.columns?.map((col) => ({
            Header: col?.title,
            accessor: pascalToCamel(col?.field),
        }));
        setTableMetadata(valueReModified);
    }, [jobContextData]);

    const getJobList = async () => {
        setLoading(true);
        const response = await submitFilterData({});
        const listData = response?.data;
        const valueReModified = listData?.map((item) => ({
            ...item,
        }));
        if (response) {
            setJobData(valueReModified);
        } else {
            setJobData([]);
        }
        setLoading(false);
    };

    const handleSearchSubmit = async (value) => {
        setLoading(true);
        const payload = {
            search: value,
        };

        const response = await submitFilterData(payload);
        const searchData = response?.data;

        if (response) {
            setJobData(searchData);
        } else {
            setJobData([]);
        }

        setLoading(false);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />
                    <Card>
                        <CardBody>
                            <div className="d-flex justify-content-between align-items-center">
                                <h5 className="fw-bold mb-3">Job</h5>
                                {jobActionPermissions.canCreate ? (
                                    <Col xs="12" md="4" className="text-md-end mt-2 mt-md-0">
                                        <Button
                                            color="primary"
                                            onClick={() => {
                                                setItemId(null);
                                                setJobAddEditModalOpen(true);
                                                setFormData(initialState);
                                            }}
                                        >
                                            + Create
                                        </Button>
                                    </Col>
                                ) : null}
                            </div>

                            <hr />

                            <Row className="align-items-center g-2 mb-4">
                                <Col xs="12" md="8">
                                    <div className="d-flex border rounded w-100 category-search-input">
                                        <Input
                                            type="text"
                                            placeholder="Search by name"
                                            className="border-0"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e?.target?.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleSearchSubmit(searchQuery?.trim());
                                                }
                                            }}
                                        />

                                        <Button
                                            className="search-icon-button"
                                            onClick={() => handleSearchSubmit(searchQuery?.trim())}
                                        >
                                            <i className="fa fa-search"></i>
                                        </Button>
                                    </div>
                                </Col>

                            </Row>

                            {(!loading && jobData?.length && tableMetaData?.length) ? (
                                <CommonTable
                                    columns={tableMetaData}
                                    data={filteredData}
                                    isActionRequired={hasAnyJobRowAction}
                                    onEdit={
                                        jobActionPermissions.canEdit ? handleEdit : undefined
                                    }
                                    isEditAccess={jobActionPermissions.canEdit}
                                    isCheckboxLeftSide={false}
                                    isPagination={false}
                                    setCommonFilterModalOpen={setCommonFilterModalOpen}
                                    pageName={"Job"}
                                />
                            ) : 
                            // <Spinners setLoading={setLoading} />
                            <Loaders />
                            }
                        </CardBody>
                    </Card>

                    <JobAddEditModal
                        setJobAddEditModalOpen={setJobAddEditModalOpen}
                        jobAddEditModalOpen={jobAddEditModalOpen}
                        getJobList={getJobList}
                        itemId={itemId}
                        setItemId={setItemId}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

Job.propTypes = {
    orders: PropTypes.array,
    onGetOrders: PropTypes.func,
};

export default withRouter(Job);
